import { Component, ViewChild, ViewEncapsulation, HostListener, OnInit, TemplateRef } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { LoginService } from '../login/login.service';
import { setLoggedInUser } from '../../Store/request.actions';
import { Store } from '@ngrx/store';
import { CookieService } from '../../services/cookie.service';
import { MatDialog } from '@angular/material/dialog';
import { MaterialModulesModule } from '../../material-modules/material-modules.module';
import { ReactiveFormsModule } from '@angular/forms';
import { NotificationsComponent } from '../notifications/notifications.component';

declare var window: any;

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports:[
      MaterialModulesModule,
      NotificationsComponent,
      ReactiveFormsModule
    ]
})
export class HeaderComponent implements OnInit {
  userConsent: string | any = null;
  private static termlyLoaded = false;
  @ViewChild('sidenav') sidenav!: MatSidenav;
  @ViewChild('logoutDialog') logoutDialog!: TemplateRef<any>;
  logoutDialogRef: any;

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent): void {
    if (this.sidenav && this.sidenav.opened && !this.isClickInsideSidenav(event)) {
      this.sidenav.close();
    }
  }

  open() {
    if (this.sidenav && this.sidenav.opened) {
      this.close();
    } else {
      this.sidenav.open();
    }
  }

  stopPropagation(event: Event): void {
    event.stopPropagation();
  }

  isClickInsideSidenav(event: MouseEvent): boolean | any {
    const sidenavElement = document.getElementById('account-sidenav');
    return sidenavElement && sidenavElement.contains(event.target as Node);
  }

  constructor(
    private loginService: LoginService,
    private router: Router,
    private store: Store,
    private cookieService: CookieService,
    private dialog: MatDialog
  ) { }
  ngOnInit(): void {
    this.loadTermlyScript();
  }

  ngAfterViewInit() {
    if (!this.cookieService.getCookie('userConsent') && this.router.url.includes('search')) {
      if (window.Termly && typeof window.Termly.reinit === 'function') {
        window.Termly.reinit();
      }
    }

    if (!this.cookieService.getCookie('userConsent')) {
      window.addEventListener('consent_given', () => {
        this.cookieService.setCookie('userConsent', 'accepted', 100 * 365 * 24 * 60);
      });

      window.addEventListener('consent_withdrawn', () => {
        this.cookieService.deleteCookie('userConsent');
      });
    }
  }

  private loadTermlyScript() {
    if (HeaderComponent.termlyLoaded) return;

    const existingScript = document.querySelector(`script[src*="termly.io/resource-blocker/6e829330-ee66-4cdc-9144-02299d825568"]`);
    if (existingScript) {
      HeaderComponent.termlyLoaded = true;
      return;
    }

    const script = document.createElement('script');
    script.id = 'termly-script';
    script.src = 'https://app.termly.io/resource-blocker/6e829330-ee66-4cdc-9144-02299d825568?autoBlock=off';
    script.type = 'text/javascript';
    script.async = true;
    script.onload = () => {
      HeaderComponent.termlyLoaded = true;
    };

    document.head.appendChild(script);

    HeaderComponent.termlyLoaded = true;
    this.userConsent = true;
  }

  close() {
    this.sidenav.close();
  }

  sideNav() {
    this.sidenav.open();
  }

  logoutBroker() {
    this.loginService.logout().subscribe({
      next: (response: any) => {
        localStorage.removeItem('token');
        localStorage.removeItem('brokerMail');
        localStorage.removeItem('brokerName');
        this.store.dispatch(setLoggedInUser({ request: null }));

        // Delete userConsent cookie
        this.cookieService.deleteCookie('userConsent');

        // Remove Termly Banner from DOM
        const banner = document.querySelector('.t-consentPrompt');
        if (banner) {
          banner.remove();
        }

        const termlyDiv = document.getElementById('termly-code-snippet-support');
        if (termlyDiv) {
          termlyDiv.remove();
        }

        // Remove termly script tag
        const script = document.getElementById('termly-script');
        if (script) {
          script.remove();
        }

        // Reset Termly global state
        if (window.Termly) {
          delete window.Termly;
        }

        // Optional: Remove any Termly-related local/session storage
        sessionStorage.clear();
        localStorage.removeItem('termly_consent_prefs');

        // Navigate without reload

        this.sidenav.close();
        HeaderComponent.termlyLoaded = false
        window.location.href = '/login';
      },
      error: (error) => {
        window.location.href = '/login';
      }
    });
  }

  confirmLogout() {
    this.logoutDialogRef = this.dialog.open(this.logoutDialog, {
      width: '350px',
      panelClass: 'delete-dialog',
      hasBackdrop: true
    });
  }
  closeLogoutDialog() {
    if (this.logoutDialogRef) {
      this.logoutDialogRef.close();
    }
  }
  confirmLogoutAction() {
    this.closeLogoutDialog();
    this.logoutBroker();
  }

  navigateToSettings() {
    this.router.navigate(['/settings'])
      .then(() => this.close())
      .catch(() => this.close());
  }
}